import { useParams } from "react-router-dom";
import Loader from "../Loader";
import loadable from "@loadable/component";

const LazySubstanceWarehouseForm = loadable(() => import("../SubstanceWarehouseForm"), { fallback: <Loader/> });
const LazySubstanceForm = loadable(() => import("../SubstanceForm"), { fallback: <Loader/> });
const LazyWarehouseItemForm = loadable(() => import("../WarehouseItemForm"), { fallback: <Loader/> });

const ITEM_TYPES = ["caps", "bottles", "machineries", "filters", "candles"];

// maintain type param in the components
// but if type === stock use the LazySubstanceWarehouseForm
// if an item of the warehouse (caps, bottles, machineries, filters, candles) use LazyWarehouseItemForm
// if treatments use LazySubstanceForm

const WarehouseUpdateRouter = () => {
  const { type } = useParams();

  if (type === "stock") {
    return <LazySubstanceWarehouseForm />;
  }

  if (ITEM_TYPES.includes(type)) {
    return <LazyWarehouseItemForm />;
  }

  return <LazySubstanceForm />;
};

export default WarehouseUpdateRouter;
